<template>
  <b-modal title="Ordem de Serviço de Faturamento" v-model="show" size="xl">
    <div id="ordemServicoFaturamento">
      <b-container fluid>
        <!-- :::::::::::::::::::::::::::: HEADER DA ORDEM DE SERVIÇO :::::::::::::::::::::::::::: -->
        <b-row class="mt-2">
          <b-col cols="2">
            <img class="m-2" :src="require('/static/images/logo_sgcq.png')" aria-label="Logomarca do SGCQ" width="160" />
          </b-col>
          <b-col cols="7">
            <h3>NEW ENERGY TECH EIRELI</h3>
            <h6>Serviços Técnicos de Consultória, Projeto, Fabricação, Inspeção de Equipamentos.</h6>
            <h6>BR 304 - Km 50,5 - Zona Rural</h6>
            <h6>Fone: (84) 9 9604-4935 / (84) 9 8740-0525</h6>
          </b-col>
          <b-col cols="3" class="text-right">
            <h6><strong>Nº de OS: </strong> {{ os.numero }}</h6>
            <h6><strong>Nº de Orçamento: </strong> {{ os.orcamento }}</h6>
            <h6><strong>Data: </strong> {{ moment(faturamento.data).format("DD/MM/YYYY") }}</h6>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="6">
            <b-form-group label="Cliente:" label-for="cliente" label-cols="2" class="m-1">
              <b-form-input id="cliente" v-model="faturamento.cliente" />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="Local:" label-for="local" label-cols="2" class="m-1">
              <b-form-input id="local" v-model="os.local" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12">
            <b-form-group label="Descrição:" label-for="desc" label-cols="1" class="m-1">
              <b-form-input id="desc" v-model="faturamento.descricao" />
            </b-form-group>
          </b-col>
        </b-row>

        <hr />
        <b-row class="mt-2">
          <b-col cols="12" class="text-center">
            <h4><strong>ORDEM DE SERVIÇO</strong></h4>
          </b-col>
        </b-row>

        <!-- :::::::::::::::::::::::::::: TABELA DE ITENS :::::::::::::::::::::::::::: -->
        <b-table bordered hover small head-variant="light" :items="lista" :fields="fields.ordemservico">
          <template #cell(data)="data">
            <div>
              <p class="pt-0 pb-0">
                {{ moment(data.item.data).format("DD/MM/YYYY") }}
              </p>
            </div>
          </template>

          <template #cell(total)="data">
            <div>
              <p>{{ formatter.format(data.item.total) }}</p>
            </div>
          </template>
        </b-table>
        <!-- :::::::::::::::::::::::::::: TOTAL :::::::::::::::::::::::::::: -->
        <b-row>
          <b-col offset="7" cols="5">
            <h5 class="text-right">
              <strong>Total: {{ formatter.format(total) }}</strong>
            </h5>
          </b-col>
        </b-row>

        <!-- :::::::::::::::::::::::::::: RODAPE DO PROTOCOLO :::::::::::::::::::::::::::: -->
        <hr />
        <b-row class="mt-2">
          <b-col cols="6" class="text-center">
            <responsavel-stamp :descricao="'Responsável pelo Serviço:'" :posicao="'10rem'" key="resp-stamp-os" />
          </b-col>
          <b-col cols="6" class="text-center">
            <div id="stamp" class="borda-redonda">
              <b-row>
                <b-col cols="12" class="m-0">
                  <p class="m-0">
                    <strong>Cliente</strong>
                  </p>
                </b-col>
                <b-col cols="12">
                  <b-form-input id="grupo" v-model="recebedor" />
                </b-col>
              </b-row>
              <b-row class="m-0">
                <b-col cols="12" class="p-0">
                  <b-form-textarea v-model="descricao" rows="3" class="text-center"></b-form-textarea>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAIS DE USO :::::::::::::::::::::::::::: -->
    <equipamento-list ref="equipamentoLista" />
    <carregar-modal ref="carregarOsModal" @update="update($event)" />

    <template #modal-footer>
      <b-button variant="primary" @click="equipamentos()">Equipamentos </b-button>
      <b-button variant="primary" @click="carregar()">Carregar</b-button>
      <b-button variant="warning" @click="limpar()">Limpar</b-button>
      <b-button variant="info" v-print="impressao">Imprimir</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import TableFields from "@/tools/TableFields";
import Faturamento from "@/models/Faturamento";
import EquipamentoListModal from "@/components/modals/equipamento/EquipamentoListModal";
import CarregarOsModal from "@/components/modals/faturamento/CarregarOsModal";
import Cliente from "@/models/Cliente";
import StampReport from "../../supports/StampReport";

export default {
  name: "ModalDeImpressaoDeProtocolo",

  components: {
    "equipamento-list": EquipamentoListModal,
    "carregar-modal": CarregarOsModal,
    "responsavel-stamp": StampReport,
  },

  data() {
    return {
      show: false,
      fields: new TableFields(),
      recebedor: "",
      descricao: "",
      os: {
        numero: 0,
        local: "Base da Netech - Mossoró",
        orcamento: "",
        data: new Date(),
        valor: Number(0.0),
        sgcq: "",
        referencia: "",
      },
      lista: [],
      data: new Date(),
      total: Number(0.0),
      faturamento: new Faturamento(0, "Novo Faturamento", "", "", new Date(), "", 0.0, false),
      informacoes: { responsavel: "", recebedor: "", signA: "", signB: "" },
      formatter: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }),
      impressao: {
        id: "ordemServicoFaturamento",
        popTitle: "SGCQ - Sistema de Gestão e Controle da Qualidade",
      },
    };
  },

  methods: {
    update(os) {
      this.os = os;
      let filtro = {
        sgcq: os.sgcq,
        codigo: "",
        nome: "",
        grupo: "",
        referencia: os.referencia,
        cliente: new Cliente(0, "Todos os Clientes", "", "", "", "", "", "", ""),
      };
      let equipamentos = this.getFilterEquipamentos(filtro);
      equipamentos.forEach((element) => {
        this.lista.push({
          sgcq: element.sgcq,
          codigo: element.codigo,
          nome: element.nome,
          data: os.data,
          servico: os.servico,
          valor: os.valor,
        });
      });
      this.total = Number(0);
      this.lista.forEach((item) => {
        this.total = this.total + Number(item.valor.replace("R$ ", "").replaceAll(".", "").replace(",", "."));
      });
      this.total = parseFloat(this.total).toFixed(2);
    },

    carregar() {
      this.$refs.carregarOsModal.call();
    },

    equipamentos() {
      this.$refs.equipamentoLista.call();
    },

    limpar() {
      this.lista = [];
      this.total = Number(0);
    },

    call(faturamento) {
      this.show = !this.show;
      this.faturamento = faturamento;
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getFilterEquipamentos } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getFilterEquipamentos,
    };
  },
};
</script>

<style lang="scss" scoped>
.borda-redonda {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 0.5rem;
}
</style>
